import { Avatar, AvatarGroup } from "@chatscope/chat-ui-kit-react"
import Skeleton from "react-loading-skeleton"
import { Swiper, SwiperSlide } from "swiper/react"

const PricingSkeleton: React.FC = () => {
    return (
        <div className="app-page pb-4">
            <h4 className="pop mx-3 mb-3 mt-5"><Skeleton width={'100%'} height={60} /></h4>
            <div className="d-flex flex-column align-items-center mt-1 my-3 gap-0">
                <span className="fs-12 fw-400 text-muted"><Skeleton width={100} /></span>
                <AvatarGroup>
                    {
                        Array.from({ length: 4 }).map((_, index) => (
                            <Skeleton key={index} width={40} height={40} circle />
                        ))
                    }
                </AvatarGroup>
            </div>
            <Swiper className="mySwiper pending-tasks-swiper" spaceBetween={16} slidesPerView={1.1}>
                <SwiperSlide>
                    <Skeleton height={400} width={'100%'} className="mb-3 app-card overflow-hidden plan-card" />
                </SwiperSlide>
                <SwiperSlide>
                    <Skeleton height={400} width={'100%'} className="mb-3 app-card overflow-hidden plan-card" />
                </SwiperSlide>
            </Swiper>
        </div>
    )
}

export default PricingSkeleton